export const companySetupStartSetup = 'start';
export const companySetupAccountStep = 'account';
export const companySetupBeginningBalanceStep = 'beginning_balance';
export const companySetupProductStep = 'product';
export const companySetupStockAdjustmentStep = 'stock_adjustment';
export const companySetupAssetStep = 'asset';
export const companySetupFinishStep = 'finish';
